import axios from "axios";

const API_URL = "https://hmc.co.il/wp-json/quatro/v1/app";
const API_URL_NEW = "https://hmc.co.il/wp-json/quatro/v1/forms";
// const STAGE_URL = "https://wordpress-1224443-4597001.cloudwaysapps.com/wp-json/quatro/v1/app";

export async function getUserDetails(license) {
  try {
    const { status, data } = await axios.get(
      `${API_URL}/profile?license=${license}`
    );
    if (status === 200 && data["status"] === "success") return data["data"];
  } catch (err) {
    throw err;
  }
}

export async function requestUpdateUserDetails(license, body) {
  try {
    const { status, data } = await axios.post(
      `${API_URL}/profile?license=${license}`,
      body
    );
    if (status === 200) return data;
  } catch (err) {
    throw err;
  }
}

export async function requestUpdateUserAvatar(license) {
  try {
    const { status, data } = await axios.post(
      `${API_URL}/profile/avatar?license=${license}`
    );
    if (status === 200) return data;
  } catch (err) {
    throw err;
  }
}

export async function sendLicensePlateForm(formData) {
  try {
    const { data } = await axios.post(`${API_URL_NEW}/car-license`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

export async function sendPolicies(formData) {
  try {
    const { data } = await axios.post(`${API_URL_NEW}/policies`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}
